export const APP_VERSION = process.env.VUE_APP_INNCASH_VERSION;
export const APP_ENV = process.env.NODE_ENV;
export const APP_BASE_URL = process.env.BASE_URL;
